import { Component, OnInit } from '@angular/core';
import { FirestoreService } from 'src/app/core/services/firestore.service';
import { Observable } from 'rxjs';
import { combineLatest, map, combineAll } from 'rxjs/operators';
import { Illustration } from 'src/app/core/interfaces/illustration';
import { Artwork } from 'src/app/core/interfaces/artwork';
import { Bookplates } from 'src/app/core/interfaces/bookplates';
import { BaseArtWork } from 'src/app/core/interfaces/base-artwork';
import { photos } from 'src/app/core/interfaces/photos';

@Component({
  selector: 'app-artgallery',
  templateUrl: './artgallery.component.html',
  styleUrls: ['./artgallery.component.scss'],
})
export class ArtgalleryComponent implements OnInit {
  illustrations: Observable<Illustration[]>;
  artwork: Observable<Artwork[]>;
  bookplate: Observable<Bookplates[]>;
 
  photos: Observable<photos[]>;

  constructor(private firestoreService: FirestoreService) {
    /* this.illustrations = this.firestoreService.getIllustration<Illustration>('Illustrations');
    this.artwork = this.firestoreService.getArtwork<Artwork>('artwork'); */
    this.bookplate = this.firestoreService.getItem<Bookplates>('bookplates');
    this.photos = this.firestoreService.getItem<BaseArtWork>('photos');
    
    
   
    /* this.allItems = this.artwork
      .pipe(combineLatest(this.artwork),
        map((artwork, illustrations) => {
          const array = artwork.concat(illustrations as any);
          console.log(array);
          return null
        })
      )  */
      
 }

  ngOnInit(): void {}
}
